module.exports = __webpack_public_path__ + "static/img/man.9dbfc2e8.png";